module.exports = __webpack_public_path__ + "static/media/team.59639d62.png";